<template>
  <div>
    <HeaderWarehouseReport :img_header="img_header" header="จำนวนสินค้าคงเหลือ" link_back="warehousereport"/>
    <Warehouse_quantity/>
  </div>
</template>

<script>
import HeaderWarehouseReport from "@/components/admin/stock/warehouse_report/headerwarehouse_report/HeaderWarehouseReport";
import img_header from "@/assets/box_qty_report.png";
import Warehouse_quantity from "@/components/admin/stock/warehouse_report/Warehouse_quantity";
export default {
  name: "WarehouseQuantity",
  components: {
    Warehouse_quantity,
    HeaderWarehouseReport
  },
  data() {
    return {
      img_header: img_header
    }
  }
}
</script>

<style scoped>

</style>
